import { render, staticRenderFns } from "./EAlertaDaBaixa.vue?vue&type=template&id=1c56745e"
import script from "./EAlertaDaBaixa.vue?vue&type=script&lang=js"
export * from "./EAlertaDaBaixa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports